module.exports = __webpack_public_path__ + "img/img12.8ba88955.png";